import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { IStoreState } from "../../../../reducers/types";
import { FlightBookPassengerSelection } from "./component";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
} from "../../../availability/reducer";

const mapStateToProps = (state: IStoreState) => ({
  searchedAdultsCount: getPackageAvailabilityAdultsCount(state),
  searchedChildrenCount: getPackageAvailabilityChildren(state).length,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightBookPassengerSelection = withRouter(
  connector(FlightBookPassengerSelection)
);
